import { Stack, Typography, Box, Divider } from "@mui/material";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import DataCell from "@/components/DataCell";
import { useAppSelector } from "@/hooks";
import { Content } from "@/types";
import { LoyaltyAccount } from "@/types/loyalty";

interface Props {
  reward: Content;
  loyaltyAccount: LoyaltyAccount;
  client: {
    name?: string;
    lastname?: string;
    phone?: string;
  };
}

const LoyaltyRedemptionPrintTemplate = ({ reward, loyaltyAccount, client }: Props) => {
  const organizationId = useAppSelector((store) => store.ui.activeOrganization);
  const currentOrganization = useAppSelector((store) => store.organizations[organizationId] ?? null);
  const branchId = useAppSelector((store) => store.ui.activeBranch);
  const currentBranch = currentOrganization?.branches?.find((b: any) => b.id === branchId);

  const pointsCost = reward.loyalty?.pointsCost || 0;
  const remainingPoints = (loyaltyAccount.currentPoints || 0) - pointsCost;
  const clientFullName = `${client.name || ""} ${client.lastname || ""}`.trim();

  return (
    <Box className="receipt-template" sx={{ bgcolor: "white", width: "100%", color: "black" }}>
      <Stack spacing={2}>
        <Stack spacing={1} alignItems="center" sx={{ textAlign: "center", mb: 2 }}>
          <Typography variant="h2" fontSize={18} sx={{ fontWeight: "bold", textTransform: "uppercase" }}>
            {currentOrganization?.title}
          </Typography>
          {currentBranch && (
            <Typography variant="body2" fontSize={12}>
              [ Sucursal: {currentBranch.title} ]
            </Typography>
          )}
          <Typography variant="h3" fontSize={14}>
            Confirmación de Canje
          </Typography>

        </Stack>

        <Divider />

        <Stack spacing={1} sx={{ mb: 2 }}>
          <DataCell label="Fecha" value={format(new Date(), "dd/MM/yyyy", { locale: es })} fontSize={12} />
          <DataCell label="Hora" value={format(new Date(), "p", { locale: es })} fontSize={12} />
          <DataCell label="Cliente" value={clientFullName || "N/A"} fontSize={12} />
          <DataCell label="Teléfono" value={client.phone || "N/A"} fontSize={12} />
          <DataCell label="Premio" value={reward.title} fontSize={12} />
          <DataCell label="Puntos necesarios" value={`${pointsCost} pts`} fontSize={12} />
          <DataCell label="Saldo restantes" value={`${remainingPoints} pts`} fontSize={12} />
        </Stack>


        <Stack spacing={2} sx={{ mt: 4 }}>
          <Stack spacing={1}>
            <Box sx={{ border: "1px solid black", height: 35, borderRadius: 1, }} />
            <Typography variant="caption" fontSize={12} textAlign="center">
              Número de Cédula
            </Typography>
          </Stack>
          <Stack spacing={1}>
            <Box sx={{ border: "1px solid black", borderRadius: 1, height: 125 }} />
            <Typography variant="caption" fontSize={12} textAlign="center">
              Firma del Cliente
            </Typography>
          </Stack>
        </Stack>

        <Typography variant="caption" fontSize={12} textAlign="center">
          Este documento es un comprobante de canje de puntos de fidelidad.
        </Typography>
      </Stack>
    </Box >
  );
};

export default LoyaltyRedemptionPrintTemplate;
